import { getFirestore, doc, getDoc, collection, getDocs } from 'firebase/firestore';

const usersDbName = `${import.meta.env.VITE_USERS_DB_PREFIX}-${import.meta.env.VITE_LOCATION_SHORTHAND}`

/**
 * Fetch user details from the `users` collection by UID.
 *
 * @param {string} uid - Firebase user id (required)
 * @returns {Promise<Object|null>} User document data, or null if not found
 * @throws {Error} If `uid` is missing or the Firestore read fails
 */
export async function getUserDetails(uid) {
  if (!uid) throw new Error('getUserDetails: missing uid');

  const db = getFirestore(usersDbName);
  const userDocRef = doc(db, 'users', uid);
  const snapshot = await getDoc(userDocRef);

  return snapshot.exists() ? snapshot.data() : null;
}

/**
 * Retrieve all user documents from the `users` collection.
 * Returns an array of user objects where each object includes the document id as `uid`.
 *
 * @returns {Promise<Array<Object>>} Array of user records (empty array if none)
 * @throws {Error} when Firestore read fails
 */
export async function getAllUsers() {
  const db = getFirestore(usersDbName);
  try {
    const usersColRef = collection(db, 'users');
    const snapshot = await getDocs(usersColRef);
    return snapshot.docs.map((d) => ({ uid: d.id, ...(d.data() || {}) }));
  } catch (err) {
    throw new Error(`getAllUsers failed: ${err && err.message ? err.message : String(err)}`);
  }
}

